export class LOCAL_STORAGE {
	static readonly APP_PROPOSTAS_HEADERS_CONFIG = 'I.MP.v.1.1'
	static readonly APP_PROPOSTA_SEARCH_PARAMS = 'I.SP.v.1.1'
	static readonly APP_CURRENT_ROUTE_BEFORE_AUTHORIZE = 'I.CRBA.V.1.1'
	static readonly APP_GARANTIAS_LOCATICIAS_INCENDIO = 'I.GL.I.v.1.1'
	static readonly APP_GARANTIAS_LOCATICIAS_FIANCA = 'I.GL.F.v.1.1'
	static readonly USER_LAST_CHANGELOG_SEEN = 'U.L.CL_S.v.1.1'
}
